/**
 * Where an Absenderzertifikat stands in its life (TM-9634 / #1608, #1587).
 *
 * The Absenderzertifikat is the certificate Therame signs a Nutzdatendatei
 * under as an Abrechnungsstelle. It is issued by the ITSG TrustCenter against a
 * PKCS#10 request (#1393) and replaced roughly yearly, so a row here is never
 * the only one for long — the previous ones stay, because a Lieferung that went
 * out under an older certificate is still on record.
 *
 * ⚠ **Exactly one row may be `ACTIVE`,** and the database enforces it rather
 * than the writer. Two active certificates would make *„which one did we sign
 * with"* a question with two answers, and the Datenannahmestelle would be the
 * one to notice.
 *
 * ⚠ **The private key is not in here, and there is no column it could hide
 * in.** It lives in a secret store or on a mounted path (#1587). What the row
 * holds is the public half of the story: fingerprint, validity, state.
 *
 * ⚠ **This enum does not drive the transition.** Requesting, importing the
 * `.p7c`, rotating and the expiry hold are TM-9637; this slice seeds one row
 * from configuration and never moves it between states.
 */
export var AbsenderzertifikatStatus;
(function (AbsenderzertifikatStatus) {
    /** *beantragt* — a PKCS#10 request is out, no certificate has come back yet. */
    AbsenderzertifikatStatus["REQUESTED"] = "requested";
    /** *aktiv* — this is the one a Lieferung signs under. At most one row. */
    AbsenderzertifikatStatus["ACTIVE"] = "active";
    /** *abgelöst* — a newer certificate took over before this one ran out. */
    AbsenderzertifikatStatus["SUPERSEDED"] = "superseded";
    /** *abgelaufen* — its `gültig bis` has passed. */
    AbsenderzertifikatStatus["EXPIRED"] = "expired";
})(AbsenderzertifikatStatus || (AbsenderzertifikatStatus = {}));
//# sourceMappingURL=absenderzertifikat-status.enum.js.map